// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T56R","option":"styles_option__24DBb","selected":"styles_selected__7npT_"};